"use server"

import { refresh } from "next/cache"

import { cookies } from "next/headers"
import { redirect } from "next/navigation"
import { errorMessage, storeApi, type ActionState } from "@/lib/api"
import { CART_COOKIE, PREVIOUS_CART_COOKIE } from "@/lib/config"

const s = (fd: FormData, k: string) => String(fd.get(k) ?? "").trim()

export async function creerDemande(_prev: ActionState, fd: FormData): Promise<ActionState> {
  let token: string
  try {
    const files = fd.getAll("photos").filter((f): f is File => f instanceof File && f.size > 0).slice(0, 4)
    let images: string[] = []
    if (files.length) {
      const upload = new FormData()
      files.forEach((f) => upload.append("files", f))
      images = (await storeApi<{ urls: string[] }>("/store/sur-mesure/photos", { body: upload })).urls
    }
    const r = await storeApi<{ token: string }>("/store/sur-mesure", {
      body: {
        name: s(fd, "name"),
        email: s(fd, "email"),
        phone: s(fd, "phone"),
        object_type: s(fd, "object_type"),
        description: s(fd, "description"),
        budget: s(fd, "budget"),
        desired_date: s(fd, "desired_date"),
        images,
      },
    })
    token = r.token
  } catch (e) {
    return { error: errorMessage(e) }
  }
  redirect(`/sur-mesure/dossier/${token}?nouveau=1`)
}

export async function repondre(token: string, _prev: ActionState, fd: FormData): Promise<ActionState> {
  try {
    await storeApi(`/store/sur-mesure/${token}/messages`, { body: { body: s(fd, "body") } })
    refresh()
    return { ok: true, message: "Message envoyé." }
  } catch (e) {
    return { error: errorMessage(e) }
  }
}

export async function accepterDevis(token: string, quoteId: string): Promise<ActionState> {
  let cartId: string
  try {
    cartId = (await storeApi<{ cart_id: string }>(`/store/sur-mesure/${token}/devis/${quoteId}/accepter`, { body: {} })).cart_id
  } catch (e) {
    return { error: errorMessage(e) }
  }
  const jar = await cookies()
  const current = jar.get(CART_COOKIE)?.value
  const opts = { httpOnly: true, sameSite: "lax" as const, path: "/", maxAge: 60 * 60 * 24 * 30 }
  // Le panier en cours est mis de côté et retrouvé après le paiement du devis.
  if (current && current !== cartId) jar.set(PREVIOUS_CART_COOKIE, current, opts)
  jar.set(CART_COOKIE, cartId, opts)
  redirect("/commande")
}

export async function refuserDevis(token: string, quoteId: string): Promise<ActionState> {
  try {
    await storeApi(`/store/sur-mesure/${token}/devis/${quoteId}/refuser`, { body: {} })
    refresh()
    return { ok: true, message: "Devis refusé. Vous pouvez écrire à la créatrice pour l’ajuster." }
  } catch (e) {
    return { error: errorMessage(e) }
  }
}
